import { defineStore } from 'pinia'
import jwtInterceptor from "@/plugins/jwtInterceptor";
import useEmitter from '@/composables/useEmitter'

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        notifications: [],
        pushNotificationsId: [],
        mercureToken: null,
        mercureTopic: null,
    }),
    persist: {
        enabled: false,
    },
    getters: {
        getAllNotifications(state){
            return state.notifications;
        },
    },
    actions: {
        async loadNotificationsFromServer(){
            console.debug("NOTIFICATIONS: refreshing the notifications from server")
            const response = await jwtInterceptor.get('v1/notification/');
            if(response && response.data){
                // Prefer body fields for iOS Capacitor compatibility; fall back to headers
                const token = response.data.mercureToken ?? response.headers?.['x-mercure-token']
                const topic = response.data.mercureTopic ?? response.headers?.['x-mercure-topic']
                if (token) this.mercureToken = token
                if (topic) this.mercureTopic = topic

                const allNotifications = Array.isArray(response.data.notifications)
                    ? response.data.notifications
                    : Array.isArray(response.data)
                        ? response.data
                        : []
                this.notifications = allNotifications
                allNotifications.forEach((element) => {
                    if(!element.isDeliveredOnMobile && !element.isRead) {
                        if (!this.pushNotificationsId.includes(element.id)) {
                            const newPushNotification = {
                                title: "New Nayak Message",
                                body: element.message,
                                id: element.id,
                                actionTypeId: "",
                                extra: null
                            }
                            const eventBus = useEmitter()
                            eventBus.emit('notification', [newPushNotification]);
                            this.pushNotificationsId.push(element.id)
                            this.markNotificationAsDelivered(element.id)
                        }
                    }
                })

            }
        },
        async markNotificationAsRead(notificationID){
            await this.markNotificationsAsRead([notificationID])
        },
        async markNotificationsAsRead(notificationIds){
            const ids = Array.isArray(notificationIds) ? notificationIds : [notificationIds]
            await Promise.all(ids.map(id => jwtInterceptor.post('v1/notification/read/' + id)))
            await this.loadNotificationsFromServer()
        },
        async markNotificationAsDelivered(id){
            try {
                await jwtInterceptor.post('v1/notification/delivered/' + id)
            } catch (e) {
                // Background call — swallow silently. Delivery retried on next load.
                console.warn('[notifications] markNotificationAsDelivered failed for id=' + id, e?.message)
            }
        },
        async deleteNotification(notificationId){
            await jwtInterceptor.delete('v1/notification/' + notificationId)
            await this.loadNotificationsFromServer()
        }
    },
})
